import React, { Component, Fragment } from 'react';
import { graphql, compose } from 'react-apollo';
import { getItemMedasByFilter, getCategoryByGenre, getNations, getLanguages } from '../../graphqlDic';
import { LIMIT_ITEMS_MEDIA } from '../../constants/Common';
import { TYPE_MOVIES, GENRE_FORM, GENRE_KIND } from '../../constants/TypesAndGenreCategory';
import FilterItemMediasComponent from '../../components/MoviePageComponent/FilterItemMediasComponent';
import FilterOptionsComponent from '../../components/MoviePageComponent/FilterOptionsComponent';

const getParamUrl = (props) => {
    let { search } = props.location ? props.location : '';
    const checkForHexRegExp = new RegExp("^[0-9a-fA-F]{24}$");
    let queryCondition = {  
        form: '',     
        languages: '',
        kind: '',     
        nation: '',
        first: LIMIT_ITEMS_MEDIA,
    }
                        
    if (search) {
        const params    = new URLSearchParams(search);
        
        queryCondition.form      = params.has('form') && checkForHexRegExp.test(params.get('form')) ? 
                                   params.get('form') : '';
        queryCondition.languages = params.has('languages') && checkForHexRegExp.test(params.get('languages')) ? 
                                   params.get('languages') : '';
        queryCondition.kind      = params.has('kind') && checkForHexRegExp.test(params.get('kind')) ? 
                                   params.get('kind') : '';
        queryCondition.nation    = params.has('nation') && checkForHexRegExp.test(params.get('nation')) ? 
                                   params.get('nation') : '';
    }

    return queryCondition;
}

class FilterPageMovies extends Component {

    render() {
        let { 
            getItemMedasByFilter, 
            getCategoryByGenreForm, 
            getCategoryByGenreKind,
            getLanguages,
            getNations
        } = this.props;

        if (
            getItemMedasByFilter.loading || 
            getCategoryByGenreForm.loading ||
            getCategoryByGenreKind.loading ||
            getLanguages.loading           ||
            getNations.loading                    
        ) return <div className="container"><p className="text-center">Loading...</p></div>;

        if (
            getItemMedasByFilter.error || 
            getCategoryByGenreForm.error ||
            getCategoryByGenreKind.error ||
            getLanguages.error           ||
            getNations.error                  
        ) return (
            `Error! ${getItemMedasByFilter.error.message} - 
                    ${getCategoryByGenreForm.error.message} - 
                    ${getCategoryByGenreKind.error.message} - 
                    ${getLanguages.error.message}           - 
                    ${getNations.error.message}             - 
            `
        );

        let dataFilter = getItemMedasByFilter.getItemMedasByFilter;
        let listCategoriesForm = getCategoryByGenreForm.getCategoryByGenre;
        let listCategoriesKind = getCategoryByGenreKind.getCategoryByGenre;
        let languages = getLanguages.getLanguages;
        let nations = getNations.getNations;

        
        return (
            <Fragment>
                <FilterOptionsComponent 
                    categoriesForm={ listCategoriesForm } 
                    categoriesKind={ listCategoriesKind } 
                    languages={ languages }
                    nations={ nations }
                    getParamUrl={ getParamUrl(this.props) }
                />

                <FilterItemMediasComponent dataFilter={ dataFilter } getParamUrl={ getParamUrl(this.props) } />
            </Fragment>
        );
    }

}

export default compose(
    graphql(getItemMedasByFilter, {
        name: 'getItemMedasByFilter',
        options: (props) => {
            let queryCondition = getParamUrl(props);
            return ({
                variables: queryCondition
            });
        }
    }),
    graphql(getCategoryByGenre, {
        name: 'getCategoryByGenreForm',
        options: (props) =>  ({
            variables: {
                genre: GENRE_FORM,
                type: TYPE_MOVIES
            }
        })
    }),
    graphql(getCategoryByGenre, {
        name: 'getCategoryByGenreKind',
        options: (props) =>  ({
            variables: {
                genre: GENRE_KIND,
                type: TYPE_MOVIES
            }
        })
    }),
    graphql(getNations, {
        name: 'getNations'
    }),
    graphql(getLanguages, {
        name: 'getLanguages'
    })
)((FilterPageMovies));



// WEBPACK FOOTER //
// ./src/containers/MoviesPage/FilterPageMovies.js